import { useLayoutEffect, useRef, useState } from 'react';
import AppLoadingOverlay from '../components/ui/AppLoadingOverlay';

export default function KycDocumentProcessingOverlay({ message, onCancel }) {
  const overlayRef = useRef(null);
  const [position, setPosition] = useState({ top: '50%', visibility: 'hidden' });
  const active = Boolean(message);
  useLayoutEffect(() => {
    if (!active) return;
    const viewport = window.visualViewport;
    const update = () => {
      const rect = overlayRef.current?.getBoundingClientRect();
      if (!rect) return;
      const viewportTop = viewport?.offsetTop || 0;
      const viewportBottom = viewportTop + (viewport?.height || window.innerHeight);
      const visibleTop = Math.max(rect.top, viewportTop);
      const visibleBottom = Math.min(rect.bottom, viewportBottom);
      const next = {
        top: `${Math.max(0, (visibleTop + visibleBottom) / 2 - rect.top)}px`,
        visibility: visibleBottom > visibleTop ? 'visible' : 'hidden',
      };
      setPosition(previous => previous.top === next.top && previous.visibility === next.visibility ? previous : next);
    };
    update();
    window.addEventListener('scroll', update, true);
    window.addEventListener('resize', update);
    viewport?.addEventListener('scroll', update);
    viewport?.addEventListener('resize', update);
    const observer = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(update) : null;
    if (overlayRef.current) observer?.observe(overlayRef.current);
    return () => {
      window.removeEventListener('scroll', update, true);
      window.removeEventListener('resize', update);
      viewport?.removeEventListener('scroll', update);
      viewport?.removeEventListener('resize', update);
      observer?.disconnect();
    };
  }, [active]);
  if (!message) return null;
  return <div ref={overlayRef} className="kycChecklistLoading">
    <div className="kycChecklistLoadingPanel" style={position}>
      <div role="status" aria-live="polite" aria-label={message}>
        <AppLoadingOverlay title={message} loaderStyle="dots" bg="transparent" />
      </div>
      {onCancel && <button type="button" className="kycChecklistCancelUpload" onClick={onCancel}>
        <i className="bi bi-x-circle" aria-hidden="true" /> Cancel upload
      </button>}
    </div>
  </div>;
}
